import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-9xl font-semibold text-[#36a8dd]" }, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl" }, "Page not found", -1)
const _hoisted_5 = { class: "mt-6 text-base leading-7 text-gray-600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 flex items-center justify-center gap-x-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/",
    class: "rounded-md bg-[#36a8dd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#36a8dd] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#36a8dd]"
  }, "Go back home")
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: '404Page',
  setup(__props) {

const messages = [
    
    "The internet isn't broken, But we can't find what you're looking for.",
    "Sorry, we couldn’t find the page you’re looking for.",
    ":(",
    "Uh Oh, it seems we can't find this page",
    "Somethings wrong, we can't find this page.",
    "This doesn't seem right. Shall we go back?",

]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(messages[Math.floor(Math.random() * 6)]), 1),
      _hoisted_6
    ])
  ]))
}
}

})